import { motion } from "framer-motion";

const items = [
  {
    n: "01",
    title: "Procurement Expertise",
    body: "Sourcing frameworks with vendor benchmarks, compliance checks and pricing discipline.",
    img: "https://images.unsplash.com/photo-1494412519320-aa613dfb7738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwc3VwcGx5JTIwY29udGFpbmVyfGVufDB8fHx8MTc4Mzg4MTM4NHww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-8",
  },
  {
    n: "02",
    title: "Project Execution",
    body: "On-site programme management with structured reporting.",
    img: "https://images.unsplash.com/photo-1608303588026-884930af2559?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxhcmNoaXRlY3QlMjBibHVlcHJpbnRzJTIwY29uc3RydWN0aW9uJTIwcHJvamVjdCUyMGV4ZWN1dGlvbnxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
  },
  {
    n: "03",
    title: "Interior Design Solutions",
    body: "Considered spaces from concept to handover.",
    img: "https://images.unsplash.com/photo-1706074797611-a02f9ed06439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjBpbnRlcmlvciUyMGRlc2lnbiUyMGx1eHVyeXxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-4",
  },
  {
    n: "04",
    title: "Supply & Distribution",
    body: "Multi-location supply orchestration with quality gates and delivery discipline.",
    img: "https://images.unsplash.com/photo-1605745341112-85968b19335b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwc3VwcGx5JTIwY29udGFpbmVyfGVufDB8fHx8MTc4Mzg4MTM4NHww&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-8",
  },
  {
    n: "05",
    title: "Infrastructure Support",
    body: "Facility upgrades, refurbishments and long-term maintenance partnerships.",
    img: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxhcmNoaXRlY3QlMjBibHVlcHJpbnRzJTIwY29uc3RydWN0aW9uJTIwcHJvamVjdCUyMGV4ZWN1dGlvbnxlbnwwfHx8fDE3ODM4ODEzODR8MA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-6",
  },
  {
    n: "06",
    title: "Customised Business Solutions",
    body: "Programmes assembled around sector-specific compliance and lead-time realities.",
    img: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMG1lZXRpbmclMjBib2FyZHJvb218ZW58MHx8fHwxNzgzODgxMzg0fDA&ixlib=rb-4.1.0&q=85",
    span: "md:col-span-6",
  },
];

export default function Capabilities() {
  return (
    <section
      id="capabilities"
      data-testid="capabilities-section"
      className="relative bg-[var(--nv-navy)] text-[var(--nv-paper)] py-28 md:py-40 nv-grain overflow-hidden"
    >
      <CapabilitiesBlueprintLayer />

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
        <div className="grid grid-cols-12 gap-6 items-end mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-6">
            <div className="overline text-[var(--nv-gold)] flex items-center gap-3">
              <span className="inline-block w-6 h-px bg-[var(--nv-gold)]" />
              <span>Capabilities</span>
            </div>
            <h2 className="mt-6 display text-5xl md:text-7xl" data-testid="capabilities-heading">
              What we can <span className="italic text-[var(--nv-gold)]">deliver.</span>
            </h2>
          </div>
          <p className="col-span-12 md:col-span-4 md:col-start-9 text-[15px] leading-relaxed text-[var(--nv-paper)]/70">
            A snapshot of what Nsoul Ventures is equipped to deliver. Each capability card is reserved for
            forthcoming case studies and completed projects.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6" data-testid="capabilities-grid">
          {items.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.9, ease: [0.7, 0, 0.3, 1], delay: (i % 3) * 0.08 }}
              className={`col-span-12 ${c.span} group relative overflow-hidden aspect-[4/3] md:aspect-[3/2]`}
              data-testid={`capability-${c.n}`}
            >
              <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 w-full h-full object-cover opacity-55 group-hover:opacity-80 transition-opacity duration-700"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[var(--nv-navy)] via-[var(--nv-navy)]/60 to-transparent" />
              <div className="relative z-10 h-full flex flex-col justify-between p-6 md:p-10">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-xs tracking-[0.24em] text-[var(--nv-gold)]">{c.n}</span>
                  <span className="overline text-[var(--nv-paper)]/60">Capability</span>
                </div>
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
                    {c.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base text-[var(--nv-paper)]/70 max-w-md">{c.body}</p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}


/* Capabilities blueprint layer — same drafting vocabulary as Hero,
   rendered on the dark navy ground with paper-coloured strokes. */
function CapabilitiesBlueprintLayer() {
  return (
    <div className="absolute inset-0 pointer-events-none z-0" aria-hidden>
      <svg
        viewBox="0 0 1600 2000"
        preserveAspectRatio="xMidYMid slice"
        className="absolute inset-0 w-full h-full opacity-[0.09]"
      >
        <defs>
          <pattern id="cap-grid-fine" x="0" y="0" width="12" height="12" patternUnits="userSpaceOnUse">
            <path d="M 12 0 L 0 0 0 12" fill="none" stroke="#FAFAFA" strokeWidth="0.35" />
          </pattern>
          <pattern id="cap-grid" x="0" y="0" width="60" height="60" patternUnits="userSpaceOnUse">
            <path d="M 60 0 L 0 0 0 60" fill="none" stroke="#FAFAFA" strokeWidth="0.55" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#cap-grid-fine)" />
        <rect width="100%" height="100%" fill="url(#cap-grid)" />

        <g stroke="#FAFAFA" strokeWidth="0.7" fill="none">
          <circle cx="1420" cy="360" r="220" strokeDasharray="2 6" />
          <circle cx="1420" cy="360" r="150" />
          <circle cx="1420" cy="360" r="4" fill="#C5A059" stroke="none" />
          <line x1="1420" y1="90" x2="1420" y2="640" strokeDasharray="1 5" />
          <line x1="1180" y1="360" x2="1660" y2="360" strokeDasharray="1 5" />
        </g>

        <g stroke="#FAFAFA" strokeWidth="0.7" fill="none">
          <path d="M 140 1360 L 300 1280 L 460 1360 L 460 1520 L 300 1600 L 140 1520 Z" />
          <path d="M 300 1280 L 300 1440 L 460 1520" />
          <path d="M 300 1440 L 140 1360" />
          <path d="M 140 1360 L 300 1280 L 460 1360 L 300 1440 Z" fill="#C5A059" fillOpacity="0.08" stroke="#C5A059" strokeOpacity="0.4" />
        </g>

        <g stroke="#FAFAFA" strokeWidth="0.6" fill="none">
          <path d="M 30 30 L 62 30 M 30 30 L 30 62" />
          <path d="M 1570 30 L 1538 30 M 1570 30 L 1570 62" />
          <path d="M 30 1970 L 62 1970 M 30 1970 L 30 1938" />
          <path d="M 1570 1970 L 1538 1970 M 1570 1970 L 1570 1938" />
        </g>

        <g fill="#C5A059">
          <circle cx="360" cy="180" r="2.6" />
          <circle cx="1080" cy="920" r="2.6" />
          <circle cx="720" cy="1780" r="2.6" />
        </g>

        <g
          fontFamily="'JetBrains Mono', ui-monospace, monospace"
          fill="#FAFAFA"
          fillOpacity="0.5"
          fontSize="10"
          letterSpacing="0.22em"
        >
          <text x="30" y="80">NV — 05 · CAPABILITIES</text>
          <text x="1570" y="80" textAnchor="end">SCALE 1:1</text>
          <text x="30" y="1930">SHEET 05/07</text>
          <text x="1570" y="1930" textAnchor="end">FIG · E</text>
        </g>
      </svg>
    </div>
  );
}
